(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7031],{

/***/ 79107:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[segment]/[local]",
      function () {
        return __webpack_require__(73668);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73668:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* reexport */ SegmentationListingPage/* default */.Z; }
});

// EXTERNAL MODULE: ./src/components/pages/segmentationListings/SegmentationListingPage.tsx + 110 modules
var SegmentationListingPage = __webpack_require__(53816);
;// CONCATENATED MODULE: ./src/components/pages/segmentationListings/index.ts


;// CONCATENATED MODULE: ./src/pages/[segment]/[local].tsx
var __N_SSP = true;



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2453,898,9417,1207,1136,1767,1036,1903,9635,2494,6492,8576,8396,4858,4875,4383,3370,6048,6925,1337,155,5498,6745,3846,1933,3816,9774,2888,179], function() { return __webpack_exec__(79107); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);